/**
 * Tipos compartidos del CRM
 * Generados desde el contrato OpenAPI (docs/openapi.json)
 */

export interface User {
  id: number
  username: string
  name: string
  email: string | null
  attention_line: string | null
  roles: string[]
  permissions: string[]
  last_login_at: string | null
  last_login_ip: string | null
  created_at: string
  updated_at: string
}

export interface AuthUser {
  id: number
  username: string
  name: string
  email: string | null
  roles: string[]
  permissions: string[]
}

export interface LoginCredentials {
  username: string
  password: string
  remember_me?: boolean
}

export interface LoginResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
  user: AuthUser
}

export interface RefreshResponse {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
}

export interface ChangePasswordRequest {
  current_password: string
  password: string
  password_confirmation: string
}

export interface ProfileUpdateRequest {
  name?: string
  email?: string | null
  phone?: string | null
}

export interface PaginationMeta {
  current_page: number
  last_page: number
  per_page: number
  total: number
  from: number | null
  to: number | null
  query: Record<string, unknown>
}

export interface PaginationQuery {
  page?: number
  per_page?: number
  sort?: string
  q?: string
  [key: string]: unknown
}

export interface ApiResponse<T> {
  data: T
  meta?: Record<string, unknown>
}

export interface PaginatedResponse<T> {
  data: T[]
  meta: PaginationMeta
}

export interface ApiError {
  code: string
  message: string
  details?: Record<string, unknown>
  meta?: Record<string, unknown>
}

export interface ApiErrorResponse {
  error: ApiError
}

export interface ValidationErrorDetails {
  fields: Record<string, string[]>
}

export interface ValidationErrorResponse {
  error: ApiError & {
    details: ValidationErrorDetails
  }
}

export type RoleName = 'admin' | 'advisor' | 'marketing'
export type PermissionName =
  | 'dashboard.access'
  | 'marketing.access'
  | 'users.manage'
  | 'customers.manage'
  | 'catalog.view'
  | 'catalog.manage'
  | 'quotes.manage'
  | 'store-sales.manage'
  | 'followup.manage'

export interface RolePermissionMatrix {
  [role: string]: PermissionName[]
}

export const ROLE_PERMISSIONS: RolePermissionMatrix = {
  admin: [
    'dashboard.access',
    'marketing.access',
    'users.manage',
    'customers.manage',
    'catalog.view',
    'catalog.manage',
    'quotes.manage',
    'store-sales.manage',
    'followup.manage',
  ],
  advisor: [
    'customers.manage',
    'catalog.view',
    'quotes.manage',
    'store-sales.manage',
    'followup.manage',
  ],
  // Marketing: mira el panel y descarga sus ficheros. Ni un permiso más.
  marketing: ['marketing.access'],
}

export const ROLES: RoleName[] = ['admin', 'advisor', 'marketing']
export const ALL_PERMISSIONS: PermissionName[] = [
  'dashboard.access',
  'marketing.access',
  'users.manage',
  'customers.manage',
  'catalog.view',
  'catalog.manage',
  'quotes.manage',
  'store-sales.manage',
  'followup.manage',
]